import React, { useState } from "react";
import useDeepCompareEffect from "use-deep-compare-effect";
import { addBlock, removeBlock, updateBlock } from "../Admin/service";
import { useScrollyTellProps } from "../Admin/scrollytellContext";
import { useIsActiveBlock } from "./useIsActiveBlock";
import { useBackgroundColor } from "../Container/useBackgroundColor";
import { renderAdminBlock } from "./AdminBlockRenderers";

export const AdminBlock = ({
  sectionId,
  containerId,
  blockId,
  block,
  isAdminMode,
  children,
}) => {
  const backgroundColor = useBackgroundColor({
    sectionId: sectionId,
    containerId: containerId,
  });

  const [blockState, setBlockState] = useState({
    data: block,
    modified: false,
  });

  const { onChange, story } = useScrollyTellProps();

  const isActiveBlock = useIsActiveBlock({
    sectionId: sectionId,
    containerId: containerId,
    blockId: blockId,
  });

  useDeepCompareEffect(() => {
    setBlockState({
      data: block,
      modified: false,
    });
  }, [block]);

  const handleUpdate = (updatedBlock) => {
    const updatedStory = updateBlock(
      story,
      sectionId,
      containerId,
      blockId,
      updatedBlock
    );
    onChange(updatedStory);
  };

  const handleCopyBlock = () => {
    const updatedStory = addBlock(story, sectionId, containerId, block);
    onChange(updatedStory);
  };

  const handleRemoveBlock = () => {
    const updatedStory = removeBlock(story, sectionId, containerId, blockId);
    onChange(updatedStory);
  };

  const handleUpdateState = (property, value) => {
    setBlockState({
      data: {
        ...blockState.data,
        [property]: value,
      },
      modified: true,
    });
  };

  const handleCommitState = () => {
    if (blockState.modified) {
      handleUpdate(blockState.data);
    }
  };

  if (isAdminMode) {
    return renderAdminBlock({
      sectionId,
      containerId,
      blockId,
      block,
      blockState,
      isActiveBlock,
      backgroundColor,
      isAdminMode,
      handleCommitState,
      handleUpdateState,
      handleUpdate,
      handleCopyBlock,
      handleRemoveBlock,
    });
  }

  return <>{children}</>;
};
